<template>
  <b-card-code title="Form Pengajuan Cuti">
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <!--  This field is required-->
          <b-col md="6">
            <b-form-group>
              <label>Nama</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="First Name"
              >
                <b-form-input
                  v-model="biodata.nama"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Nama"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!--Enter Number between 10 & 20 -->
          <b-col md="6">
            <b-form-group>
              <label>NIP / NUP</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="NIP / NUP"
                
              >
                <b-form-input
                  v-model="biodata.nip"
                  :state="errors.length > 0 ? false:null"
                  placeholder="NIP / NUP"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Must only consist of numbers-->
          <b-col md="6">
            <b-form-group>
              <label>Unit Kerja</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Unit Kerja"
              >
                <b-form-input
                  v-model="biodata.unit_kerja"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Unit Kerja"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Must match the specified regular expression : ^([0-9]+)$ - numbers only -->
          <b-col md="6">
            <b-form-group>
              <label>Masa Kerja</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Masa Kerja"
              >
                <b-form-input
                  v-model="biodata.masa_kerja"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Masa Kerja"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- <b-col md="6">
            <b-form-group>
              <label>Sisa Cuti</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Sisa Cuti"
              >
                <b-form-input
                  v-model="numberRegx"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Sisa Cuti"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col> -->

        </b-row>
        <b-row class="mt-3">
          <!--  Only alphabetic characters-->
          <b-col md="6">
            <b-form-group>
              <label>Jenis Cuti</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="jenis cuti"
              >
                <v-select
                  :options="leaveOptions"
                  v-model="jenis_cuti_id"
                  :class="{'is-invalid': errors.length > 0}"
                  placeholder="Pilih Jenis Cuti"
                  :reduce="val => val.value"
                  :disabled="true"
                ></v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-form-group>
              <label>Tanggal Mulai Cuti</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Tanggal Mulai Cuti"
              >
                <flat-pickr
                  v-model="tanggalMulaiCuti"
                  :config="dateConfig"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  placeholder="Pilih Tanggal Mulai Cuti"
                  @input="(val) => formatTanggalMulaiCuti(val)"
                  :disabled="true"
                ></flat-pickr>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Tanggal Selesai Cuti</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Tanggal Selesai Cuti"
              >
                <flat-pickr
                  v-model="tanggalSelesaiCuti"
                  :config="dateConfig"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  placeholder="Pilih Tanggal Selesai Cuti"
                  @input="(val) => formatTanggalSelesaiCuti(val)"
                  :disabled="true"
                ></flat-pickr>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Lama Cuti</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Lama Cuti"
              >
                <b-form-input
                  v-model="lamaCuti"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Lama Cuti"
                  :readonly="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Sisa Cuti</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Sisa Cuti"
              >
                <b-form-input
                  v-model="biodata.sisa_cuti"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Sisa Cuti"
                  :type="'number'"
                  :readonly="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>

          <!-- Length should not be less than the specified length : 3 -->
          <b-col md="6">
            <b-form-group>
              <label>Alasan Cuti</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Alasan Cuti"
              >
                <b-form-textarea
                  v-model="alasanCuti"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Alasan Cuti"
                  rows="5"
                  :readonly="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label>Alamat Selama Cuti</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Alamat Cuti"
              >
                <b-form-textarea
                  v-model="alamatCuti"
                  :state="errors.length > 0 ? false : null"
                  placeholder="alamat Cuti"
                  rows="5"
                  :readonly="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="this.catatan != null">
            <b-form-group>
              <label>Catatan Penolakan</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Catatan Penolakan"
              >
                <b-form-textarea
                  v-model="catatan"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Catatan Penolakan"
                  rows="5"
                  :readonly="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
      <!-- submit button -->
      <b-col cols="12">
        <b-button
          variant="primary"
          @click.prevent="showModal"
        >
          Approve
        </b-button>
        <b-button
          variant="danger"
          @click.prevent="showModalTolak"
          class="ml-1"
        >
          Tolak
        </b-button>
        </b-col>
      </b-row>

      <!-- Confirmation Modal -->
      <b-modal
        id="confirmation-modal"
        title="Konfirmasi"
        @ok="approve()"
      >
        <p class="text-center my-4">Apakah anda menyetujui pengajuan cuti ini?</p>
        <label for="">Nomor Surat</label>
        <b-form-input v-if="this.userData.role == 'admin'" placeholder="Masukan Nomor Surat" v-model="nomorSurat"></b-form-input>
      </b-modal>
      <b-modal
        id="confirmation-modal-tolak"
        title="Konfirmasi Penolakan"
        @ok="tolak()"
      >
        <p class="text-center my-4">Berikan alasan penolakan anda.</p>
        <b-form-textarea
        placeholder="Catatan Penolakan"
        rows="5"
        v-model="catatan"
        >
        </b-form-textarea>

      </b-modal>
      </b-form>
    </validation-observer>

    <!-- <template #code>
      {{ codeType }}
    </template> -->
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormTextarea, BModal,
} from 'bootstrap-vue'
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations'
import { codeType } from './code'
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  getUserPengaju,
  getJenisCuti,
  postCuti,
  getDetailPengajuanCuti,
  tolakPengajuanCuti,
  approvePengajuanCuti,
} from '@/connection-api/pengajuan-cuti/api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { readonly } from '@vue/composition-api'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormTextarea,
    flatPickr,
    BModal,
  },
  data() {
      const n = new Date()
      let tahun = n.getFullYear()
    return {
      nomorSurat: `NOMOR/UN2.F8.WD.SVA/SDM.03.00.Cuti Pegawai/${tahun}`,
      catatan: '',
      userData: {},
      biodata: {},
      name: '',
      passwordValue: '',
      passwordCon: '',
      emailValue: '',
      number: '',
      numberRange: '',
      numberRegx: '',
      URL: '',
      Alphabetic: '',
      digitValue: '',
      digitValue2: '',
      character: '',
      required,
      confirmed,
      password,
      email,
      min,
      integer,
      url,
      alpha,
      between,
      digits,
      length,
      alphaDash,
      codeType,
      jenis_cuti_id: null,
      leaveOptions: [],
      alasanCuti: "",
      tanggalMulaiCuti: null,
      tanggalSelesaiCuti: null,
      calculateMulai: null,
      calculateSelesai: null,
      dateConfig: {
        dateFormat: "d-m-Y"
      },
      lamaCuti: 0,
      alamatCuti: "",
    }
  },
  mounted() {
    this.getAllData()
  },
  methods: {
    showModal() {
      this.$bvModal.show('confirmation-modal');
    },
    showModalTolak() {
      this.$bvModal.show('confirmation-modal-tolak');
    },
    approve() {
      let data = null

      if(this.userData.role == 'admin')
      {
        let text = this.nomorSurat
        let result = text.includes('NOMOR')
        if(result == true)
        {
          alert('Edit nomor surat terlebih dahulu.')
        } else {
          data = {
            uuid: this.$route.params.uuid,
            nomor_surat: this.nomorSurat
          }
        }
      } else {
        data = {
          uuid: this.$route.params.uuid
        }
      }

      if(data != null) {
        approvePengajuanCuti(data)
        .then(response => {
          if (response.data.success == true) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Pengajuan E-Cuti',
                icon: 'EditIcon',
                variant: 'success',
                text: 'Data Berhasil Disetujui',
              },
            })
            setTimeout(() => {
                this.$router.push({ 
                  name: 'daftar-list-cuti', 
                  // params: { uuid: response.data.data.uuid } 
                })
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Pengajuan E-Cuti',
                icon: 'EditIcon',
                variant: 'danger',
                text: 'Data Tidak Ditemukan',
              },
            })
          }
        })
        .catch(error => console.log(error));
      }
    },
    tolak() {
      let data = {
        catatan_penolakan: this.catatan,
        uuid: this.$route.params.uuid
      }
      tolakPengajuanCuti(data)
      .then(response => {
        if (response.data.success == true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data Berhasil Ditolak',
            },
          })
          setTimeout(() => {
              this.$router.push({ 
                name: 'daftar-list-cuti', 
                // params: { uuid: response.data.data.uuid } 
              })
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
    },
    getAllData() {
      getDetailPengajuanCuti(this.$route.params.uuid)
      .then(response => {
        if (response.data.success == true) {
          this.userData = response.data.data
          this.jenis_cuti_id =this.userData.jenis_cuti_id
          this.tanggalMulaiCuti =this.userData.tanggal_mulai_cuti
          this.tanggalSelesaiCuti = this.userData.tanggal_selesai_cuti
          this.lamaCuti = this.userData.lama_cuti
          this.alamatCuti = this.userData.alamat_cuti
          this.alasanCuti =this.userData.alasan_cuti
          this.catatan = this.userData.catatan_penolakan
          this.nomorSurat = this.userData.nomor_surat != null ? this.userData.nomor_surat : this.nomorSurat
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data User Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
      //=======================================
      getUserPengaju(this.$route.params.uuid)
      .then(response => {
        if (response.data.success == true) {
          this.biodata = response.data.data
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data User Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
      //=======================================
      getJenisCuti()
      .then(response => {
        if (response.data.success == true) {
          //gunakan response.data.data
          this.leaveOptions = response.data.data.map(item => ({
            label: item.nama,
            value: item.id,
          }));
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data Jenis Cuti Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
      //=======================================
      
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          this.userData.jenis_cuti_id = this.jenis_cuti_id
          this.userData.tanggal_mulai_cuti = this.tanggalMulaiCuti
          this.userData.tanggal_selesai_cuti = this.tanggalSelesaiCuti
          this.userData.lama_cuti = this.lamaCuti
          this.userData.alamat_cuti = this.alamatCuti
          this.userData.alasan_cuti = this.alasanCuti

          postCuti(this.userData)
            .then(response => {
              if (response.data.success == true) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Cuti',
                    icon: 'EditIcon',
                    variant: 'success',
                    text: 'Data berhasil disimpan',
                  },
                  duration: 5000,
                })
                setTimeout(() => {
                this.$router.push({ 
                  name: 'daftar-list-cuti', 
                  // params: { uuid: response.data.data.uuid } 
                })
              }, 1000);
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Cuti',
                    icon: 'EditIcon',
                    variant: 'danger',
                    text: 'Data gagal disimpan',
                  },
                })
              }
            })
            .catch(error => console.log(error));
        }
      })
    },
    formatTanggalMulaiCuti(selectedDates) {
      if (selectedDates.length) {
        this.calculateMulai = this.formatDate(selectedDates[0]);
        this.calculateLamaCuti();
      }
    },
    formatTanggalSelesaiCuti(selectedDates) {
      if (selectedDates.length) {
        this.calculateSelesai = this.formatDate(selectedDates[0]);
        this.calculateLamaCuti();
      }
    },
    formatDate(date) {
      const d = new Date(date);
      const day = (`0${d.getDate()}`).slice(-2);
      const month = (`0${d.getMonth() + 1}`).slice(-2);
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },
    calculateLamaCuti() {
      if (this.tanggalMulaiCuti && this.tanggalSelesaiCuti) {
        const mulai = new Date(this.parseDate(this.tanggalMulaiCuti));
        const selesai = new Date(this.parseDate(this.tanggalSelesaiCuti));
        const diffTime = selesai - mulai;
        this.lamaCuti = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Tambah 1 hari untuk mengikutsertakan tanggal mulai cuti
      } else {
        this.lamaCuti = 0;
      }
    },
    parseDate(dateString) {
      const parts = dateString.split('-');
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
  },
}
</script>
